<template>
<div>
  <div v-show="!showInterfaceList">
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r10 vertical-center-box">관리 대상</div>
        <el-select class="mr-r4" v-model="managetypeId" style="width: 92px;">
          <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
        </el-select>
        <el-select class="mr-r4" v-show="false" v-model="managetypeKey" style="width:90px;">
          <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
        </el-select>
        <el-select v-show="managetypeId === 'NMS'" v-model="objCompanyId" style="width:110px;" placeholder="제조사" clearable>
          <el-option v-for="item in objCompanyList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
        </el-select>
        <el-select class="mr-r4" v-show="managetypeId !== 'NMS' && managetypeId !== 'SVC' && managetypeId !== 'E2E' && managetypeId !== 'VMS'" v-model="objtypeId" style="width:110px;" placeholder="장비 종류" clearable>
          <el-option v-for="item in objtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
        </el-select>
        <el-select v-show="managetypeId == 'VMS'" v-model="hypervisorType" style="width:110px;" placeholder="하이퍼바이저 종류" clearable>
          <el-option v-for="item in hypervisorTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
        </el-select>
      </div>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <!-- 0429 a-left 추가 -->
    <el-table-wrapper class="a-left" :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight" ref="objTable" :data="tableData" :total="total"
    :columns="columns" :show-search-tool="showSearchTool" remote pagination :show-custom-header="showCustomHeader" @condition-change="onConditionChange"
      @select="onSelect" @select-all="onSelectAll">
      <template slot-scope="scope" slot="interface-slot">
        <i class="el-icon-search" style="cursor: pointer" @click="onClickInterfaceButton(scope.row)" />
      </template>
    </el-table-wrapper>
  </div>
  <w-interface-table v-show="showInterfaceList" ref="interfaceTable" :active="showInterfaceList" :device-data="selectedDeviceData" :filter-params="filterParams"
  :checked-obj-list="checkedObjList" @on-click-back-button="showInterfaceList = !showInterfaceList" />
</div>
</template>

<script>
import { isEmpty, isNil, filter, cloneDeep } from 'lodash';
import { isTrue } from '@/utils/boolean';
import managetypeKeyApi from '@/api/model/managetype-key';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { columnDefault, agentPhysicalObjTableColumns } from '@/constants/table';
import WInterfaceTable from '@/components/table/PhysicalObjTable/components/InterfaceTable';

export default {
  name: 'WAgentPhysicalObjTable',
  components: {
    WInterfaceTable,
  },
  props: {
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    checkedObjList: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      managetypeList: [],
      managetypeId: null,
      managetypeKeyList: [],
      managetypeKey: null,
      objCompanyList: null,
      objCompanyId: null,
      objtypeList: null,
      objtypeId: null,
      hypervisorTypeList: null,
      hypervisorType: null,
      showSearchTool: false,
      showCustomHeader: true,
      showInterfaceColumn: true,
      showInterfaceList: false,
      tableData: null,
      originTableData: null,
      total: null,
      columnDefault,
      agentPhysicalObjTableColumns,
      columns: [],
      loadKey: null,
      selectedDeviceData: {},
    };
  },
  computed: {
    filterParams() {
      return {
        params: this.loadKey,
      };
    },
  },
  watch: {
    loadKey: {
      handler(to, from) {
        if (!isEmpty(to)) {
          if (isEmpty(from) || to.managetypeId !== from.managetypeId || to.managetypeKey !== from.managetypeKey) {
            // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
            // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
            this.columns = [];
            this.$refs.objTable.clearFilter();
            this.$nextTick(() => {
              this.columns = this.getColumns();
            });
          }
          this.loadData();
        }
      },
    },
    managetypeId(to) {
      if (to === null) {
        return;
      }

      if (to === 'NMS') {
        this.loadManagetypeKey(to);
      } else {
        this.managetypeKeyList = null;
        this.managetypeKey = null;
        if (to === 'VMS') {
          this.loadHypervisorType();
          this.loadKey = {
            managetypeId: to,
            hypervisorType: null,
          };
        } else {
          this.loadObjtype(to);
          this.loadKey = {
            managetypeId: to,
            objtypeId: null,
          };
        }
      }
    },
    /**
     * 관리 구분 키 변경
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    managetypeKey(to) {
      if (to === null) {
        return;
      }

      if (this.managetypeId === 'NMS') {
        this.loadCompany(this.managetypeId);
        this.loadKey = {
          managetypeId: this.managetypeId,
          managetypeKey: to,
          objCompanyId: null,
        };
      } else if (this.managetypeId === 'VMS') {
        this.loadHypervisorType();
        this.loadKey = {
          managetypeId: this.managetypeId,
          managetypeKey: to,
          hypervisorType: null,
        };
      }
    },
    /**
     * 벤더 변경
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    objCompanyId(to) {
      if (to === null) {
        return;
      }

      let objCompanyId;
      if (to === '') {
        objCompanyId = null;
      } else {
        objCompanyId = to;
      }

      this.loadKey = {
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeKey,
        objCompanyId,
      };
    },
    /**
     * 장비 종류 변경
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    objtypeId(to) {
      if (to === null) {
        return;
      }

      let objtypeId;
      if (to === '') {
        objtypeId = null;
      } else {
        objtypeId = to;
      }

      this.loadKey = {
        managetypeId: this.managetypeId,
        objtypeId,
      };
    },
    hypervisorType(to) {
      if (to === null) {
        return;
      }

      let hypervisorType;
      if (to === '') {
        hypervisorType = null;
      } else {
        hypervisorType = to;
      }

      this.loadKey = {
        managetypeId: this.managetypeId,
        hypervisorType,
      };
    },
  },
  methods: {
    initData() {
      this.loadManagetype();
    },
    /**
     * 물리 그룹 관리 대상 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = {
        ...this.loadKey,
        ...this.$refs.objTable.getParameter(),
      };
      logicalGroupApi
        .getPhysicalObjList(tableParams)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            result.data.forEach((row) => {
              const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
              row.checked = !isNil(checkedObj) ? 1 : 0;
            });
            this.tableData = result.data;
            this.total = result.total;
            const originalData = filter(result.data, (item) => item.checked);
            this.originTableData = originalData;
            this.$nextTick(() => {
              this.toggleRowSelection(originalData);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          // this.managegrpObjData.loading = false;
          this.tableData = [];
          this.total = 0;
        });
    },
    changeTableHeader() {
      this.columns = [];
      this.$refs.objTable.clearFilter();
      this.$nextTick(() => {
        this.columns = this.getColumns();
      });
    },
    loadManagetype() {
      const managetypeList = filter(this.$store.getters.activeManagetypes, (item) => isTrue(item.showFlag));
      if (isNil(managetypeList)) {
        this.loadManagetype();
      } else {
        this.managetypeList = managetypeList;
        if (!isNil(this.selectedManagetypeId)) {
          this.managetypeId = this.selectedManagetypeId;
        } else {
          this.managetypeId = this.managetypeList[0].managetypeId;
        }
      }
    },
    loadManagetypeKey(managetypeId) {
      managetypeKeyApi
        .getDisplayedManagetypeKeyList(managetypeId)
        .then((response) => {
          if (!isEmpty(response.data) && response.data.success === true && !isEmpty(response.data.data)) {
            this.managetypeKeyList = response.data.data;
            this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
          } else {
            this.managetypeKeyList = null;
            this.managetypeKey = null;
          }
        })
        .catch(() => {
          this.managetypeKeyList = null;
          this.managetypeKey = null;
        });
    },
    loadCompany(managetypeId) {
      logicalGroupApi
        .getUsingObjCompanyList({ managetypeId })
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.objCompanyList = result.data;
            this.objCompanyId = null;
          } else {
            this.objCompanyList = null;
            this.objCompanyId = null;
          }
        })
        .catch(() => {
          this.objCompanyList = null;
          this.objCompanyId = null;
        });
    },
    loadObjtype(managetypeId) {
      logicalGroupApi
        .getUsingObjtypeList(managetypeId)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.objtypeList = result.data;
            this.objtypeId = null;
          } else {
            this.objtypeList = null;
            this.objtypeId = null;
          }
        })
        .catch(() => {
          this.objtypeList = null;
          this.objtypeId = null;
        });
    },
    loadHypervisorType() {
      BasicinfoSubAPI
        .getList('HYPERVISOR_TYPE')
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            this.hypervisorTypeList = result.data;
            this.hypervisorType = null;
          } else {
            this.hypervisorTypeList = null;
            this.hypervisorType = null;
          }
        })
        .catch(() => {
          this.hypervisorTypeList = null;
          this.hypervisorType = null;
        });
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onConditionChange() {
      this.loadData();
    },
    /**
     * 테이블 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelect(selection, row) {
      const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
      if (!isNil(checkedObj)) {
        this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
      } else {
        this.checkedObjList.push(row);
      }
    },
    onSelectAll(selection) {
      const tableData = this.tableData;
      tableData.forEach((row) => {
        const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
        if (selection.length > 0) {
          if (isNil(checkedObj)) {
            this.checkedObjList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedObj)) {
            this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
          }
        }
      });
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.objTable.getTable().selection;
    },
    /**
     * 테이블 행 선택을 토글한다.
     * @author Ju
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.objTable.getTable().toggleRowSelection(row);
      });
    },
    /**
     * 모든 행 선택을 해제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearSelection() {
      this.$refs.objTable.getTable().clearSelection();
    },
    /**
     * 관리 구분에 맞는 테이블 정보를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getColumns() {
      let columns;
      const managetypeId = this.managetypeId;
      if (managetypeId === 'NMS') {
        if (this.managetypeKey === 'ND') {
          columns = this.agentPhysicalObjTableColumns.netdeviceColumns;
        } else {
          columns = this.agentPhysicalObjTableColumns.netinterfaceColumns;
        }
      } else if (managetypeId === 'SMS') {
        columns = this.agentPhysicalObjTableColumns.serverColumns;
      } else if (managetypeId === 'E2E') {
        columns = this.agentPhysicalObjTableColumns.e2eColumns;
      } else if (managetypeId === 'FMS') {
        columns = this.agentPhysicalObjTableColumns.sensorColumns;
      } else if (managetypeId === 'DBMS') {
        columns = this.agentPhysicalObjTableColumns.dbColumns;
      } else if (managetypeId === 'SVC') {
        columns = this.agentPhysicalObjTableColumns.serviceColumns;
      } else if (managetypeId === 'VMS') {
        columns = this.agentPhysicalObjTableColumns.virtualcenterColumns;
      } else if (managetypeId === 'EMS') {
        columns = this.agentPhysicalObjTableColumns.emsColumns;
      } else if (managetypeId === 'APM2X') {
        columns = this.agentPhysicalObjTableColumns.wasColumns;
      } else {
        columns = [];
      }
      return columns;
    },
    setCheckObjTable() {
      this.$refs.interfaceTable.setCheckObjTable();
      if (!isNil(this.tableData)) {
        this.tableData.forEach((row) => {
          const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
          row.checked = !isNil(checkedObj) ? 1 : 0;
        });
        const originalData = filter(this.tableData, (item) => item.checked);
        this.$nextTick(() => {
          this.clearSelection();
          this.toggleRowSelection(originalData);
        });
      }
    },
    onClickInterfaceButton(row) {
      this.selectedDeviceData = row;
      this.showInterfaceList = !this.showInterfaceList;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/components/AgentPhysicalObjTable.vue